import React from 'react';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';
import SelectedProfilesHeader from './SelectedProfilesHeader';
import { getIntl } from '../../../utils/intl';
import SelectedClientProfilesHeader from './SelectedClientProfilesHeader';
import LargeTextInput from '../../v2BaseComponents/Inputs/LargeTextInput';
import { APITypes } from '../../../primary-record-types';

const intl = getIntl('profile-messaging-input', {
    message: 'Message',
});

export type ProfileMessageInputOwnProps = {
    selectedProfileIds: string[];
    message: string;
    setMessage: (message: string) => void;
    type: 'client-profiles' | 'profiles' | 'profile';
    isDisabled?: boolean;
};

export type ProfileMessageInputProps = ProfileMessageInputOwnProps;

const ProfileMessageInput: React.FC<ProfileMessageInputProps> = ({
    selectedProfileIds,
    message,
    setMessage,
    type,
    isDisabled,
}) => {
    const renderHeader = () => {
        if (type === 'profiles') {
            return <SelectedProfilesHeader selectedProfileIds={selectedProfileIds} />;
        } else if (type === 'client-profiles') {
            return <SelectedClientProfilesHeader selectedProfileIds={selectedProfileIds} />;
        } else {
            return null;
        }
    };

    return (
        <Stack vertical space={contentStackSpacing} flex={1}>
            {renderHeader()}
            <LargeTextInput
                value={message}
                onChange={(e) => setMessage(e.nativeEvent.text)}
                placeholder={intl('message')}
                testID="add-message-content"
                isDisabled={isDisabled}
                maxLength={APITypes.auditLogService.MAX_PROFILE_MESSAGE_LENGTH}
            />
        </Stack>
    );
};

export default React.memo(ProfileMessageInput);
